import { CLINICAL_TRIALS_CUBE_NAME, HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME } from '@/api/hcp';
import { Stars } from '@/components/shared/rating';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { SelectItem } from '@/types/ui';
import { Filter } from '@cubejs-client/core';
import { TRIAL_SPONSOR_FILTER_LIMIT } from '../../filterDefaultLimits';
import { FilterValue } from '../../FilterType';

const TRIAL_SPONSOR_OPTIONS: GetOptionsQueryFunction = () => ({
  dimensions: [`${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_label`],
  limit: TRIAL_SPONSOR_FILTER_LIMIT,
  filters: [
    {
      dimension: `${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_category`,
      operator: 'equals',
      values: ['sponsor'],
    },
  ],
});

const trialSponsorFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.trialSponsorLabel',
  placeholder: 'global.filters.formControls.trialSponsorPlaceholder',
  defaultValue: null,
  sourceCube: CLINICAL_TRIALS_CUBE_NAME,
  type: 'multilevelselect',
  searchable: true,
  clearable: true,
  getOptionsQuery: TRIAL_SPONSOR_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_label`),
  format: ({ value }: { value: FilterValue }) => {
    const v = value as SelectItem;
    const label = v.value === 'other' ? 'Other' : v.label;
    return [
      <span key={`label-${v.value}${v.level}`}>{label}</span>,
      <Stars key={`stars-${v.value}-${v.level}`} value={v.level} />,
    ];
  },
  applyFilter: value => {
    const v = value as SelectItem[];
    const trialSponsorsFilter: Filter = {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_category`,
          operator: 'equals',
          values: ['sponsor'],
        },
        {
          or: v.map(t => {
            return {
              and: [
                {
                  member: `${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_label`,
                  operator: 'equals',
                  values: [t.value],
                },
                {
                  member: `${HCP_SCIENTIFIC_ACTIVITY_SPONSOR_CUBE_NAME}.score_value`,
                  operator: 'gte',
                  values: [t.level.toString()],
                },
              ],
            };
          }),
        },
      ],
    };
    return trialSponsorsFilter;
  },
};

export default trialSponsorFilter;
